import {Injectable} from '@angular/core';
import {delay, Observable, of} from 'rxjs';
import type {ContactEvent} from '../types/contacts.types';
import type {UserEventsApi} from './user-events-api.port';

const MOCK_DELAY_MS = 200;

@Injectable()
export class UserEventsApiMockAdapter implements UserEventsApi {
  private nextId = 3;
  private readonly events: ContactEvent[] = [
    {
      id: '1',
      name: 'نوروز',
      usedCount: 0,
      type: 'shared',
      eventDate: '1403/01/01',
    },
    {
      id: '2',
      name: 'تولدهای اردیبهشت',
      usedCount: 0,
      type: 'individual',
      eventDate: null,
    },
  ];

  listEvents(_needUsedCount = false): Observable<ContactEvent[]> {
    return of(this.events.map(event => ({...event}))).pipe(delay(MOCK_DELAY_MS));
  }

  createEvent(name: string): Observable<ContactEvent> {
    const event: ContactEvent = {
      id: String(this.nextId++),
      name: name.trim(),
      usedCount: 0,
      type: 'shared',
      eventDate: null,
    };
    this.events.push(event);
    return of({...event}).pipe(delay(MOCK_DELAY_MS));
  }

  updateEvent(id: string, name: string): Observable<void> {
    const event = this.events.find(item => item.id === id);
    if (event) {
      event.name = name.trim();
    }
    return of(undefined).pipe(delay(MOCK_DELAY_MS));
  }

  deleteEvent(id: string): Observable<void> {
    const index = this.events.findIndex(item => item.id === id);
    if (index >= 0) {
      this.events.splice(index, 1);
    }
    return of(undefined).pipe(delay(MOCK_DELAY_MS));
  }
}
